import { Grid, Space } from "../Layout";
import { Texts, Title, Media, Button, Link } from "../Object";
import { WorksList } from "../Post";

const Works = (props) => {
  return (
    <>
      <div className="p-box__wrap">
        <Media
          src="box-back/works"
          alt="background"
          class="p-box__img--back"
        ></Media>
        <div className="p-box__wrap--white p-works__wrap--row">
          <Title slug="works"></Title>
          <Space size={["100px 0 80px", "64px 0 48px"]}>
            <div className="p-works__wrap--slider l-row--sp">
              <WorksList></WorksList>
            </div>
          </Space>
          <Button type="center" slug="works" link="/works/"></Button>
        </div>
      </div>
    </>
  );
};

export default Works;